export default "__VITE_ASSET__BYSgW4Cs__"